var globals = {
  hammerjs: require('hammerjs')
};

module.exports = globals;
